import React from 'react';
import { Image, StyleSheet } from 'react-native';

import { Theme } from '@constants';

import largeHomePin from '../../assets/map/map_home_pin_large.png';
import smallHomePin from '../../assets/map/map_home_pin_small.png';

const largeHomePinSize = { width: Theme.px(42), height: Theme.px(42) };
const smallHomePinSize = { width: Theme.px(30), height: Theme.px(30) };

export const MapHomePinSize = {
  small: 'small',
  large: 'large',
};

export const MapHomePin = ({ size, x, y }) => {
  let pinSource = smallHomePin;
  let pinStyle = {};

  if (size === MapHomePinSize.small) {
    pinSource = smallHomePin;
    pinStyle = [
      styles.smallPin,
      {
        left: x - smallHomePinSize.width / 2,
        top: y - smallHomePinSize.height / 2,
      },
    ];
  } else if (size === MapHomePinSize.large) {
    pinSource = largeHomePin;
    pinStyle = [
      styles.largePin,
      {
        left: x - largeHomePinSize.width / 2,
        top: y - largeHomePinSize.height / 2,
      },
    ];
  }

  return <Image source={pinSource} style={pinStyle} />;
};

const styles = StyleSheet.create({
  largePin: {
    overflow: 'hidden',
    position: 'absolute',
    resizeMode: 'contain',
    ...largeHomePinSize,
  },
  smallPin: {
    overflow: 'hidden',
    position: 'absolute',
    resizeMode: 'contain',
    ...smallHomePinSize,
  },
});
